const countryNames = {
  BR: { pt: 'Brasil', en: 'Brazil', es: 'Brasil' },
  US: { pt: 'Estados Unidos', en: 'United States', es: 'Estados Unidos' },
  EC: { pt: 'Equador', en: 'Ecuador', es: 'Ecuador' },
  MX: { pt: 'México', en: 'Mexico', es: 'México' },
  VN: { pt: 'Vietnã', en: 'Vietnam', es: 'Vietnam' },
  AR: { pt: 'Argentina', en: 'Argentina', es: 'Argentina' },
  PT: { pt: 'Portugal', en: 'Portugal', es: 'Portugal' },
  ES: { pt: 'Espanha', en: 'Spain', es: 'España' },
  FR: { pt: 'França', en: 'France', es: 'Francia' },
  DE: { pt: 'Alemanha', en: 'Germany', es: 'Alemania' },
  IT: { pt: 'Itália', en: 'Italy', es: 'Italia' },
  GB: { pt: 'Reino Unido', en: 'United Kingdom', es: 'Reino Unido' },
  RU: { pt: 'Rússia', en: 'Russia', es: 'Rusia' },
  CN: { pt: 'China', en: 'China', es: 'China' },
  JP: { pt: 'Japão', en: 'Japan', es: 'Japón' },
  IN: { pt: 'Índia', en: 'India', es: 'India' },
  AF: { pt: 'Afeganistão', en: 'Afghanistan', es: 'Afganistán' },
  AL: { pt: 'Albânia', en: 'Albania', es: 'Albania' },
  DZ: { pt: 'Argélia', en: 'Algeria', es: 'Argelia' },
  AS: { pt: 'Samoa Americana', en: 'American Samoa', es: 'Samoa Americana' },
  AD: { pt: 'Andorra', en: 'Andorra', es: 'Andorra' },
  AO: { pt: 'Angola', en: 'Angola', es: 'Angola' },
  AG: {
    pt: 'Antígua e Barbuda',
    en: 'Antigua and Barbuda',
    es: 'Antigua y Barbuda',
  },
  AM: { pt: 'Armênia', en: 'Armenia', es: 'Armenia' },
  AU: { pt: 'Austrália', en: 'Australia', es: 'Australia' },
  AT: { pt: 'Áustria', en: 'Austria', es: 'Austria' },
  AZ: { pt: 'Azerbaijão', en: 'Azerbaijan', es: 'Azerbaiyán' },
  BS: { pt: 'Bahamas', en: 'Bahamas', es: 'Bahamas' },
  BH: { pt: 'Bahrein', en: 'Bahrain', es: 'Baréin' },
  BD: { pt: 'Bangladesh', en: 'Bangladesh', es: 'Bangladés' },
  BB: { pt: 'Barbados', en: 'Barbados', es: 'Barbados' },
  BY: { pt: 'Bielorrússia', en: 'Belarus', es: 'Bielorrusia' },
  BE: { pt: 'Bélgica', en: 'Belgium', es: 'Bélgica' },
  BZ: { pt: 'Belize', en: 'Belize', es: 'Belice' },
  BJ: { pt: 'Benim', en: 'Benin', es: 'Benín' },
  BM: { pt: 'Bermudas', en: 'Bermuda', es: 'Bermudas' },
  BT: { pt: 'Butão', en: 'Bhutan', es: 'Bután' },
  BO: { pt: 'Bolívia', en: 'Bolivia', es: 'Bolivia' },
  BA: {
    pt: 'Bósnia e Herzegovina',
    en: 'Bosnia and Herzegovina',
    es: 'Bosnia y Herzegovina',
  },
  BW: { pt: 'Botsuana', en: 'Botswana', es: 'Botsuana' },
  PE: { pt: 'Peru', en: 'Peru', es: 'Perú' },
  CL: { pt: 'Chile', en: 'Chile', es: 'Chile' },
  PL: { pt: 'Polônia', en: 'Poland', es: 'Polonia' },
  NL: { pt: 'Países Baixos', en: 'Netherlands', es: 'Países Bajos' },
  PK: { pt: 'Paquistão', en: 'Pakistan', es: 'Pakistán' },
  CA: { pt: 'Canadá', en: 'Canada', es: 'Canadá' },
  SE: { pt: 'Suécia', en: 'Sweden', es: 'Suecia' },
  IE: { pt: 'Irlanda', en: 'Ireland', es: 'Irlanda' },
  PA: { pt: 'Panamá', en: 'Panama', es: 'Panamá' },
  GT: { pt: 'Guatemala', en: 'Guatemala', es: 'Guatemala' },
  TH: { pt: 'Tailândia', en: 'Thailand', es: 'Tailandia' },
  SG: { pt: 'Singapura', en: 'Singapore', es: 'Singapur' },
  PY: { pt: 'Paraguai', en: 'Paraguay', es: 'Paraguay' },
  KR: { pt: 'Coreia do Sul', en: 'South Korea', es: 'Corea del Sur' },
  UY: { pt: 'Uruguai', en: 'Uruguay', es: 'Uruguay' },
  PH: { pt: 'Filipinas', en: 'Philippines', es: 'Filipinas' },
  CH: { pt: 'Suíça', en: 'Switzerland', es: 'Suiza' },
  TW: { pt: 'Taiwan', en: 'Taiwan', es: 'Taiwán' },
  VE: { pt: 'Venezuela', en: 'Venezuela', es: 'Venezuela' },
  CR: { pt: 'Costa Rica', en: 'Costa Rica', es: 'Costa Rica' },
  DO: {
    pt: 'República Dominicana',
    en: 'Dominican Republic',
    es: 'República Dominicana',
  },
  RO: { pt: 'Romênia', en: 'Romania', es: 'Rumanía' },
  TR: { pt: 'Turquia', en: 'Turkey', es: 'Turquía' },
  MY: { pt: 'Malásia', en: 'Malaysia', es: 'Malasia' },
  UA: { pt: 'Ucrânia', en: 'Ukraine', es: 'Ucrania' },
  DK: { pt: 'Dinamarca', en: 'Denmark', es: 'Dinamarca' },
  GR: { pt: 'Grécia', en: 'Greece', es: 'Grecia' },
  LT: { pt: 'Lituânia', en: 'Lithuania', es: 'Lituania' },
  BG: { pt: 'Bulgária', en: 'Bulgaria', es: 'Bulgaria' },
  SA: { pt: 'Arábia Saudita', en: 'Saudi Arabia', es: 'Arabia Saudita' },
  EG: { pt: 'Egito', en: 'Egypt', es: 'Egipto' },
  IL: { pt: 'Israel', en: 'Israel', es: 'Israel' },
  CZ: { pt: 'Tchéquia', en: 'Czechia', es: 'Chequia' },
  SV: { pt: 'El Salvador', en: 'El Salvador', es: 'El Salvador' },
  NO: { pt: 'Noruega', en: 'Norway', es: 'Noruega' },
  HK: { pt: 'Hong Kong', en: 'Hong Kong', es: 'Hong Kong' },
  PR: { pt: 'Porto Rico', en: 'Puerto Rico', es: 'Puerto Rico' },
  FI: { pt: 'Finlândia', en: 'Finland', es: 'Finlandia' },
  MZ: { pt: 'Moçambique', en: 'Mozambique', es: 'Mozambique' },
  GE: { pt: 'Geórgia', en: 'Georgia', es: 'Georgia' },
  AE: {
    pt: 'Emirados Árabes Unidos',
    en: 'United Arab Emirates',
    es: 'Emiratos Árabes Unidos',
  },
  CV: { pt: 'Cabo Verde', en: 'Cape Verde', es: 'Cabo Verde' },
  HU: { pt: 'Hungria', en: 'Hungary', es: 'Hungría' },
  ZA: { pt: 'África do Sul', en: 'South Africa', es: 'Sudáfrica' },
  HR: { pt: 'Croácia', en: 'Croatia', es: 'Croacia' },
  UZ: { pt: 'Uzbequistão', en: 'Uzbekistan', es: 'Uzbekistán' },
  KZ: { pt: 'Cazaquistão', en: 'Kazakhstan', es: 'Kazajistán' },
  SK: { pt: 'Eslováquia', en: 'Slovakia', es: 'Eslovaquia' },
  LK: { pt: 'Sri Lanka', en: 'Sri Lanka', es: 'Sri Lanka' },
  HN: { pt: 'Honduras', en: 'Honduras', es: 'Honduras' },
  MN: { pt: 'Mongólia', en: 'Mongolia', es: 'Mongolia' },
  MM: { pt: 'Mianmar', en: 'Myanmar', es: 'Birmania' },
  QA: { pt: 'Catar', en: 'Qatar', es: 'Catar' },
  MA: { pt: 'Marrocos', en: 'Morocco', es: 'Marruecos' },
  MO: { pt: 'Macau', en: 'Macau', es: 'Macao' },
  SI: { pt: 'Eslovênia', en: 'Slovenia', es: 'Eslovenia' },
  NZ: { pt: 'Nova Zelândia', en: 'New Zealand', es: 'Nueva Zelanda' },
  LU: { pt: 'Luxemburgo', en: 'Luxembourg', es: 'Luxemburgo' },
  MK: {
    pt: 'Macedônia do Norte',
    en: 'North Macedonia',
    es: 'Macedonia del Norte',
  },
  CI: { pt: 'Costa do Marfim', en: 'Ivory Coast', es: 'Costa de Marfil' },
  MT: { pt: 'Malta', en: 'Malta', es: 'Malta' },
  EE: { pt: 'Estônia', en: 'Estonia', es: 'Estonia' },
  JO: { pt: 'Jordânia', en: 'Jordan', es: 'Jordania' },
  KG: { pt: 'Quirguistão', en: 'Kyrgyzstan', es: 'Kirguistán' },
  KH: { pt: 'Camboja', en: 'Cambodia', es: 'Camboya' },
  LV: { pt: 'Letônia', en: 'Latvia', es: 'Letonia' },
  PS: { pt: 'Palestina', en: 'Palestine', es: 'Palestina' },
  GF: { pt: 'Guiana Francesa', en: 'French Guiana', es: 'Guayana Francesa' },
  JM: { pt: 'Jamaica', en: 'Jamaica', es: 'Jamaica' },
  IQ: { pt: 'Iraque', en: 'Iraq', es: 'Irak' },
  KW: { pt: 'Kuwait', en: 'Kuwait', es: 'Kuwait' },
  LA: { pt: 'Laos', en: 'Laos', es: 'Laos' },
  MV: { pt: 'Maldivas', en: 'Maldives', es: 'Maldivas' },
  NG: { pt: 'Nigéria', en: 'Nigeria', es: 'Nigeria' },
  TT: {
    pt: 'Trinidad e Tobago',
    en: 'Trinidad and Tobago',
    es: 'Trinidad y Tobago',
  },
  MD: { pt: 'Moldávia', en: 'Moldova', es: 'Moldavia' },
  NP: { pt: 'Nepal', en: 'Nepal', es: 'Nepal' },
  RS: { pt: 'Sérvia', en: 'Serbia', es: 'Serbia' },
  MH: { pt: 'Ilhas Marshall', en: 'Marshall Islands', es: 'Islas Marshall' },
  GN: { pt: 'Guiné', en: 'Guinea', es: 'Guinea' },
  OM: { pt: 'Omã', en: 'Oman', es: 'Omán' },
  CY: { pt: 'Chipre', en: 'Cyprus', es: 'Chipre' },
  GP: { pt: 'Guadalupe', en: 'Guadeloupe', es: 'Guadalupe' },
  NI: { pt: 'Nicarágua', en: 'Nicaragua', es: 'Nicaragua' },
  GY: { pt: 'Guiana', en: 'Guyana', es: 'Guyana' },
  ST: {
    pt: 'São Tomé e Príncipe',
    en: 'Sao Tome and Principe',
    es: 'Santo Tomé y Príncipe',
  },
  LY: { pt: 'Líbia', en: 'Libya', es: 'Libia' },
  TC: {
    pt: 'Ilhas Turcas e Caicos',
    en: 'Turks and Caicos Islands',
    es: 'Islas Turcas y Caicos',
  },
  AW: { pt: 'Aruba', en: 'Aruba', es: 'Aruba' },
  BN: { pt: 'Brunei', en: 'Brunei', es: 'Brunéi' },
  BF: { pt: 'Burkina Faso', en: 'Burkina Faso', es: 'Burkina Faso' },
  BI: { pt: 'Burundi', en: 'Burundi', es: 'Burundi' },
  CM: { pt: 'Camarões', en: 'Cameroon', es: 'Camerún' },
  CF: {
    pt: 'República Centro-Africana',
    en: 'Central African Republic',
    es: 'República Centroafricana',
  },
  TD: { pt: 'Chade', en: 'Chad', es: 'Chad' },
  KM: { pt: 'Comores', en: 'Comoros', es: 'Comoras' },
  CG: { pt: 'Congo', en: 'Congo', es: 'Congo' },
  CD: {
    pt: 'Congo (República Democrática)',
    en: 'Democratic Republic of the Congo',
    es: 'República Democrática del Congo',
  },
  CK: { pt: 'Ilhas Cook', en: 'Cook Islands', es: 'Islas Cook' },
  CU: { pt: 'Cuba', en: 'Cuba', es: 'Cuba' },
  CW: { pt: 'Curaçao', en: 'Curaçao', es: 'Curazao' },
  DJ: { pt: 'Djibuti', en: 'Djibouti', es: 'Yibuti' },
  DM: { pt: 'Dominica', en: 'Dominica', es: 'Dominica' },
  GQ: {
    pt: 'Guiné Equatorial',
    en: 'Equatorial Guinea',
    es: 'Guinea Ecuatorial',
  },
  ER: { pt: 'Eritreia', en: 'Eritrea', es: 'Eritrea' },
  SZ: { pt: 'Essuatíni', en: 'Eswatini', es: 'Esuatini' },
  FJ: { pt: 'Fiji', en: 'Fiji', es: 'Fiyi' },
  GA: { pt: 'Gabão', en: 'Gabon', es: 'Gabón' },
  GM: { pt: 'Gâmbia', en: 'Gambia', es: 'Gambia' },
  GH: { pt: 'Gana', en: 'Ghana', es: 'Ghana' },
  GI: { pt: 'Gibraltar', en: 'Gibraltar', es: 'Gibraltar' },
  GL: { pt: 'Groenlândia', en: 'Greenland', es: 'Groenlandia' },
  GD: { pt: 'Granada', en: 'Grenada', es: 'Granada' },
  GU: { pt: 'Guam', en: 'Guam', es: 'Guam' },
  GW: { pt: 'Guiné-Bissau', en: 'Guinea-Bissau', es: 'Guinea-Bisáu' },
  HT: { pt: 'Haiti', en: 'Haiti', es: 'Haití' },
  IS: { pt: 'Islândia', en: 'Iceland', es: 'Islandia' },
  IM: { pt: 'Ilha de Man', en: 'Isle of Man', es: 'Isla de Man' },
  JE: { pt: 'Jersey', en: 'Jersey', es: 'Jersey' },
  KI: { pt: 'Quiribáti', en: 'Kiribati', es: 'Kiribati' },
  LS: { pt: 'Lesoto', en: 'Lesotho', es: 'Lesoto' },
  LI: { pt: 'Liechtenstein', en: 'Liechtenstein', es: 'Liechtenstein' },
  MG: { pt: 'Madagáscar', en: 'Madagascar', es: 'Madagascar' },
  MW: { pt: 'Malawi', en: 'Malawi', es: 'Malaui' },
  ML: { pt: 'Mali', en: 'Mali', es: 'Malí' },
  MR: { pt: 'Mauritânia', en: 'Mauritania', es: 'Mauritania' },
  MU: { pt: 'Maurício', en: 'Mauritius', es: 'Mauricio' },
  FM: { pt: 'Micronésia', en: 'Micronesia', es: 'Micronesia' },
  MC: { pt: 'Mônaco', en: 'Monaco', es: 'Mónaco' },
  ME: { pt: 'Montenegro', en: 'Montenegro', es: 'Montenegro' },
  NA: { pt: 'Namíbia', en: 'Namibia', es: 'Namibia' },
  NR: { pt: 'Nauru', en: 'Nauru', es: 'Nauru' },
  NE: { pt: 'Níger', en: 'Niger', es: 'Níger' },
  PG: {
    pt: 'Papua-Nova Guiné',
    en: 'Papua New Guinea',
    es: 'Papúa Nueva Guinea',
  },
  RW: { pt: 'Ruanda', en: 'Rwanda', es: 'Ruanda' },
  WS: { pt: 'Samoa', en: 'Samoa', es: 'Samoa' },
  SM: { pt: 'San Marino', en: 'San Marino', es: 'San Marino' },
  SN: { pt: 'Senegal', en: 'Senegal', es: 'Senegal' },
  SC: { pt: 'Seicheles', en: 'Seychelles', es: 'Seychelles' },
  SL: { pt: 'Serra Leoa', en: 'Sierra Leone', es: 'Sierra Leona' },
  SB: { pt: 'Ilhas Salomão', en: 'Solomon Islands', es: 'Islas Salomón' },
  SO: { pt: 'Somália', en: 'Somalia', es: 'Somalia' },
  SS: { pt: 'Sudão do Sul', en: 'South Sudan', es: 'Sudán del Sur' },
  SD: { pt: 'Sudão', en: 'Sudan', es: 'Sudán' },
  SR: { pt: 'Suriname', en: 'Suriname', es: 'Surinam' },
  TJ: { pt: 'Tajiquistão', en: 'Tajikistan', es: 'Tayikistán' },
  TZ: { pt: 'Tanzânia', en: 'Tanzania', es: 'Tanzania' },
  TG: { pt: 'Togo', en: 'Togo', es: 'Togo' },
  TO: { pt: 'Tonga', en: 'Tonga', es: 'Tonga' },
  TM: { pt: 'Turcomenistão', en: 'Turkmenistan', es: 'Turkmenistán' },
  TV: { pt: 'Tuvalu', en: 'Tuvalu', es: 'Tuvalu' },
  UG: { pt: 'Uganda', en: 'Uganda', es: 'Uganda' },
  VU: { pt: 'Vanuatu', en: 'Vanuatu', es: 'Vanuatu' },
  YE: { pt: 'Iémen', en: 'Yemen', es: 'Yemen' },
  ZM: { pt: 'Zâmbia', en: 'Zambia', es: 'Zambia' },
  ZW: { pt: 'Zimbábue', en: 'Zimbabwe', es: 'Zimbabue' },
  CO: { pt: 'Colômbia', en: 'Colombia', es: 'Colombia' },
  ID: { pt: 'Indonésia', en: 'Indonesia', es: 'Indonesia' },
}

// Gera um mapa reverso para busca por nome (pt, en, es)
const nameToCode = {}
Object.entries(countryNames).forEach(([code, names]) => {
  Object.values(names).forEach((name) => {
    nameToCode[name.toLowerCase()] = code
  })
})

export function getCountryName(input, lang = 'pt') {
  // Se receber um objeto com countryName, retorna direto
  if (typeof input === 'object' && input && input.countryName) {
    return input.countryName
  }
  // Se receber string, segue lógica normal
  if (typeof input === 'string') {
    const code = input.toUpperCase()
    if (countryNames[code]) {
      return countryNames[code][lang] || countryNames[code]['pt'] || code
    }
    // Busca por nome (case-insensitive) usando o mapa
    const codeFromName = nameToCode[input.toLowerCase()]
    if (codeFromName && countryNames[codeFromName]) {
      return (
        countryNames[codeFromName][lang] ||
        countryNames[codeFromName]['pt'] ||
        codeFromName
      )
    }
    return input
  }
  return '-'
}

export function getCountryCode(name) {
  if (typeof name !== 'string') return undefined
  return nameToCode[name.toLowerCase()]
}
